import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { DrrHttpClient } from '../../../../http/drr-http-client'
import { ReviewPaginationSchema } from './review.model'
import { ReviewPagination, ReviewRequestParams } from './review.types'

@Injectable({
  providedIn: 'root',
})
export class ReviewService {

  constructor(
    private httpClient: DrrHttpClient,
  ) { }

  getReviews$(businessId: string, params: ReviewRequestParams): Observable<ReviewPagination> {
    return this.httpClient
      .get<ReviewPagination>(`/bff/tow-destinations/aars/ratings/${businessId}/reviews`, {
        params: {
          ...(params?.limit !== undefined && params?.limit !== null
            ? { limit: params.limit.toString() }
            : {}),
        },
      })
      .pipe(tap((response) => ReviewPaginationSchema.validateSync(response)))
  }

}
